import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/update/license.update.mutation.gql"
import type {
  LicenseUpdateMutation,
  LicenseUpdateMutationVariables,
} from "@/v2-backoffice-client/license/update/__types__/license.update.mutation"

type Options = MutationHookOptions<
  LicenseUpdateMutation,
  LicenseUpdateMutationVariables
>

export function useLicenseUpdateMutation(options?: Options) {
  return useMutation<LicenseUpdateMutation, LicenseUpdateMutationVariables>(
    mutation,
    options,
  )
}
